import { useGetApiSchoolSettingsQuery } from 'shared/api/gsp';

import { useSetFavicon } from './hooks';

export const useGetSchool = () => {
  const { isLoading } = useGetApiSchoolSettingsQuery();

  useSetFavicon();

  return { isLoading };
};
